var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form-select',{attrs:{"error":_vm.error,"value":_vm.value,"required":_vm.required,"name":_vm.name,"label":_vm.name,"options":_vm.options,"labelClasses":_vm.labelClasses,"inputHolderClasses":_vm.inputHolderClasses},model:{value:(_vm.vat),callback:function ($$v) {_vm.vat=$$v},expression:"vat"}})
}
var staticRenderFns = []

export { render, staticRenderFns }